import { Fragment, useState } from "react";
import React from "react";
import {
  Dialog,
  Menu,
  Transition,
  Listbox,
  Disclosure,
} from "@headlessui/react";
import { Link, Navigate, useParams } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  ShoppingBagIcon,
  MenuAlt2Icon,
  UsersIcon,
  ArchiveIcon,
  XIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
  DocumentIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Leadmodaledit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      success: false,
      redirect: false,
      error_list: [],
      employeeList: [],
      stateList: [],
      countryList: [],
      leadsourcesList: [],
      leadstatusList: [],
      lead_status_id: 0,
      lead_source_id: 0,
      employee_id: null,
      name: null,
      position: "",
      email_address: "",
      website: "",
      phone: "",
      lead_value: "",
      company: "",
      description: "",
      attention: "",
      country_region_id: "",
      address_street_one: "",
      address_street_two: "",
      city: "",
      state_id: "",
      zip_code: "",
      loader: "",
      overLay: "",
      product: "",
      vehicle: "",
      service_type: "",
      lead_date: "",
      service_type_id: null,
      serviceTypeList: [],
      leadId: this.props.leadId,
    };
    this.handleInput = this.handleInput.bind(this);
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open");
    this.setState({ sidebarOpen: true });
  };
  componentDidMount() {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");
    //const { id } = this.props.params;

    const res1 = axios
      .get("public/api/lead/edit/" + this.state.leadId, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res1) => {
        this.setState({
          lead_status_id: res1.data.lead.lead_status_id,
          lead_source_id: res1.data.lead.lead_source_id,
          employee_id: res1.data.lead.employee_id,
          name: res1.data.lead.name,
          position: res1.data.lead.position,
          email_address: res1.data.lead.email_address,
          website: res1.data.lead.website,
          phone: res1.data.lead.phone,
          lead_value: res1.data.lead.lead_value,
          company: res1.data.lead.company,
          description: res1.data.lead.description,
          attention: res1.data.lead.attention,
          country_region_id: res1.data.lead.country_region_id,
          address_street_one: res1.data.lead.address_street_one,
          address_street_two: res1.data.lead.address_street_two,
          city: res1.data.lead.city,
          state_id: res1.data.lead.state_id,
          stateList: res1.data.lead.states,
          zip_code: res1.data.lead.zip_code,
          product: res1.data.lead.product,
          vehicle: res1.data.lead.vehicle,
          service_type: res1.data.lead.service_type,
          lead_date: res1.data.lead.lead_date,
          service_type_id: res1.data.lead.service_type_id,
        });
      });

    const res2 = axios
      .get("public/api/countries", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res2) => {
        this.setState({ countryList: res2.data.countries });
      });

    const res3 = axios
      .get("public/api/lead/statuses", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res3) => {
        this.setState({ leadstatusList: res3.data.lead_statuses });
      });

    const res4 = axios
      .get("public/api/lead/sources", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res4) => {
        this.setState({ leadsourcesList: res4.data.lead_source });
      });

    const res5 = axios
      .get("public/api/employees", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res5) => {
        this.setState({ employeeList: res5.data.employees });
      });

    const res6 = axios
      .get("public/api/servicetypes", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res6) => {
        this.setState({ serviceTypeList: res6.data.service_type });
      });

    setTimeout(
      function () {
        //Start the timer
        this.closeLoaderFuncion();
        this.setState({ loader: "" }); //After 1 second, set render to true
      }.bind(this),
      500
    );
  }

  handleInput = (e) => {
    var token = localStorage.getItem("token");
    if (e.target.name === "country_region_id") {
      this.setLoaderFunction();
      this.setState({ loader: "animate-pulse" });
      const res = axios
        .get("public/api/states/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.closeLoaderFuncion();
          //console.log(res.data.states);
          this.setState({ loader: "" });
          this.setState({ stateList: res.data.states });
        });
    } else {
    }

    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  responsesent = (e) => {
    this.props.handleInputlead(e);
  };

  updateLead = async (e) => {
    e.preventDefault();
    this.setLoaderFunction();
    const { id } = this.props.params;
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post(
      "public/api/lead/update/" + this.state.leadId,
      this.state,
      {
        headers,
      }
    );

    if (res.data.success) {
      this.responsesent(res.data.success);
      this.closeLoaderFuncion();
    } else {
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
      this.closeLoaderFuncion();
    }
    this.closeLoaderFuncion();
  };

  sidebarfun = async (e) => {
    console.log("a");
    this.setState({ sidebarOpen: true });
    this.setState({ setSidebarOpen: true });
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      return <Navigate to={"/LeadList"} />;
    }

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
        <div>
          {/* Static sidebar for desktop */}
          <div className={this.state.overLay} aria-hidden="true" />
          <div className="flex flex-col flex-1">
            <main className="flex-1">
              <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  <h1 className="text-2xl font-semibold text-gray-900">
                    Update Lead
                  </h1>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}

                  <div className="hidden sm:block" aria-hidden="true">
                    <div className="py-5">
                      <div className="border-t border-gray-200" />
                    </div>
                  </div>
                  <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                    <div className="md:grid md:gap-6">
                      <div className="mt-5 md:mt-0 md:col-span-2">
                        <form onSubmit={this.updateLead}>
                          <div className="shadow overflow-hidden sm:rounded-md">
                            <div className="px-4 py-5 bg-white sm:p-6">
                              <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="name"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                      Name
                                    
                                  </label>
                                  <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    value={this.state.name}
                                    onChange={this.handleInput}
                                    autoComplete="name"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="name-error"
                                  >
                                    {this.state.error_list.name}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="phone"
                                    className="block text-sm font-medium text-gray-700"
                                  ><span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                    Phone
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    name="phone"
                                    id="phone"
                                    value={this.state.phone}
                                    onChange={this.handleInput}
                                    autoComplete="phone"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="phone-error"
                                  >
                                    {this.state.error_list.phone}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="vehicle"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Vehicle
                                  </label>
                                  <input
                                    type="text"
                                    name="vehicle"
                                    value={this.state.vehicle}
                                    id="vehicle"
                                    onChange={this.handleInput}
                                    autoComplete="vehicle"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="vehicle-error"
                                  >
                                    {this.state.error_list.vehicle}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="product"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Product
                                  </label>
                                  <input
                                    type="text"
                                    name="product"
                                    value={this.state.product}
                                    id="product"
                                    onChange={this.handleInput}
                                    autoComplete="product"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="product-error"
                                  >
                                    {this.state.error_list.product}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="description"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Description
                                  </label>
                                  <input
                                    type="text"
                                    name="description"
                                    id="description"
                                    value={this.state.description}
                                    onChange={this.handleInput}
                                    autoComplete="description"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="description-error"
                                  >
                                    {this.state.error_list.description}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="service_type_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    
                                      Service Type
                                    
                                  </label>
                                  <select
                                    id="service_type_id"
                                    name="service_type_id"
                                    value={this.state.service_type_id}
                                    onChange={this.handleInput}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                  >
                                    <option value="0">------</option>
                                    {this.state.serviceTypeList.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="service_type_id-error"
                                  >
                                    {this.state.error_list.service_type_id}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="lead_source_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    {" "}
                                    <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                      Lead Source
                                    </span>
                                  </label>
                                  <select
                                    id="lead_source_id"
                                    name="lead_source_id"
                                    value={this.state.lead_source_id}
                                    onChange={this.handleInput}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                  >
                                    <option value="0">------</option>
                                    {this.state.leadsourcesList.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="lead_source_id-error"
                                  >
                                    {this.state.error_list.lead_source_id}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="lead_status_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                      Status
                                    </span>
                                  </label>

                                  <select
                                    id="lead_status_id"
                                    name="lead_status_id"
                                    value={this.state.lead_status_id}
                                    onChange={this.handleInput}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                  >
                                    <option value="0">------</option>
                                    {this.state.leadstatusList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.lead_status_id}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="employee_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    {" "}
                                   
                                      Employee
                                   
                                  </label>
                                  <select
                                    id="employee_id"
                                    name="employee_id"
                                    value={this.state.employee_id}
                                    onChange={this.handleInput}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                  >
                                    <option value="0">------</option>
                                    {this.state.employeeList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="employee_id-error"
                                  >
                                    {this.state.error_list.employee_id}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="lead_value"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Lead Value
                                  </label>
                                  <input
                                    type="text"
                                    name="lead_value"
                                    id="lead_value"
                                    value={this.state.lead_value}
                                    onChange={this.handleInput}
                                    autoComplete="lead_value"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="lead_value-error"
                                  >
                                    {this.state.error_list.lead_value}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                  <div>
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                                      Contact Info
                                    </h3>
                                  </div>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="lead_date"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    
                                      Date
                                    
                                  </label>
                                  <input
                                    type="date"
                                    name="lead_date"
                                    id="lead_date"
                                    onChange={this.handleInput}
                                    autoComplete="lead_date"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="lead_date-error"
                                  >
                                    {this.state.error_list.lead_date}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="position"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Position
                                  </label>
                                  <input
                                    type="text"
                                    name="position"
                                    id="position"
                                    value={this.state.position}
                                    onChange={this.handleInput}
                                    autoComplete="position"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="position-error"
                                  >
                                    {this.state.error_list.position}
                                  </p>
                                </div>
                                
                                
                                
                                
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="email_address"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Email
                                  </label>
                                  <input
                                    type="text"
                                    name="email_address"
                                    id="email_address"
                                    value={this.state.email_address}
                                    onChange={this.handleInput}
                                    autoComplete="email_address"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email_address-error"
                                  >
                                    {this.state.error_list.email_address}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="website"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    {" "}
                                    Website
                                  </label>
                                  <input
                                    type="text"
                                    name="website"
                                    id="website"
                                    value={this.state.website}
                                    onChange={this.handleInput}
                                    autoComplete="website"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="website-error"
                                  >
                                    {this.state.error_list.website}
                                  </p>
                                </div>
                               
                                
                                <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                  <div>
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                                      Address Details
                                    </h3>
                                  </div>
                                </div>
                               
                                
                                
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="company"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    {" "}
                                    Company
                                  </label>
                                  <input
                                    type="text"
                                    name="company"
                                    id="company"
                                    value={this.state.company}
                                    onChange={this.handleInput}
                                    autoComplete="company"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="company-error"
                                  >
                                    {this.state.error_list.company}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="attention"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Attention
                                  </label>
                                  <input
                                    type="text"
                                    name="attention"
                                    id="attention"
                                    value={this.state.attention}
                                    onChange={this.handleInput}
                                    autoComplete="attention"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="attention-error"
                                  >
                                    {this.state.error_list.attention}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="country_region_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Country
                                  </label>
                                  <select
                                    id="country_region_id"
                                    name="country_region_id"
                                    value={this.state.country_region_id}
                                    onChange={this.handleInput}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                  >
                                    <option value="0">------</option>
                                    {this.state.countryList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="country_region_id-error"
                                  >
                                    {this.state.error_list.country_region_id}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="address_street_one"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Street Address 1
                                  </label>
                                  <input
                                    type="text"
                                    name="address_street_one"
                                    value={this.state.address_street_one}
                                    id="address_street_one"
                                    onChange={this.handleInput}
                                    autoComplete="address_street_one"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="address_street_one-error"
                                  >
                                    {this.state.error_list.address_street_one}
                                  </p>
                                </div>{" "}
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="address_street_two"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Street Address 2
                                  </label>
                                  <input
                                    type="text"
                                    name="address_street_two"
                                    value={this.state.address_street_two}
                                    id="address_street_two"
                                    onChange={this.handleInput}
                                    autoComplete="address_street_two"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="address_street_two-error"
                                  >
                                    {this.state.error_list.address_street_two}
                                  </p>
                                </div>{" "}
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    City
                                  </label>
                                  <input
                                    type="text"
                                    name="city"
                                    id="city"
                                    value={this.state.city}
                                    onChange={this.handleInput}
                                    autoComplete="city"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="city-error"
                                  >
                                    {this.state.error_list.city}
                                  </p>
                                </div>{" "}
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="state_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    {" "}
                                    State
                                  </label>
                                  <select
                                    id="state_id"
                                    name="state_id"
                                    value={this.state.state_id}
                                    onChange={this.handleInput}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                  >
                                    <option value="0">------</option>
                                    {this.state.stateList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="state_id-error"
                                  >
                                    {this.state.error_list.state_id}
                                  </p>
                                </div>{" "}
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="descripzip_codetion"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Pincode
                                  </label>
                                  <input
                                    type="text"
                                    name="zip_code"
                                    id="zip_code"
                                    value={this.state.zip_code}
                                    onChange={this.handleInput}
                                    autoComplete="zip_code"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="zip_code-error"
                                  >
                                    {this.state.error_list.zip_code}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                              <button
                                type="submit"
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* /End replace */}
                </div>
              </div>
            </main>
          </div>
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Saved
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default (props) => <Leadmodaledit {...props} params={useParams()} />;
